query BlastPage($blastId: ID!, $tz: String, $page: Int, $status: String) {

  blast(id: $blastId) {
    id
    blastStatistics {
      sentCount
      queuedCount
      failedCount
      sendingCount
      sentCount
    }
    insertedAt(tz: $tz)
    processedAt(tz: $tz)
    processingFailedAt(tz: $tz)
    teacherPhoneNumber {
      id
      formattedNumber
      displayName
    }
  }

  communicationList(blastId: $blastId, page: $page, status: $status) {
    count
    remaining
    list {
      ...on Message {
        __typename
        id
        insertedAt(tz: $tz)
        conversation {
          id
          homeNumber {
            id
            label
            formattedNumber
            students {
              id
              first
              last
            }
          }
        }
        direction
        bodies {
          id
          text
          isCanon
          isOriginal
          homeLanguage {
            id
            name
            language
          }
        }
        moods {
          id
          name
        }
        status
      }
    }
  }

}
